/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../component/component';
import './printable_check_log_events';
import '../glyph/glyph_icon';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "printable_check": {
                "nested": {
                  "DownloadPrintableCheckResponse": {
                    "fields": {
                      "checkPdf": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "pdfFilename": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CancelPrintableCheckResponse": {
                    "fields": {
                      "success": {
                        "type": "squareup.bbfrontend.common.printable_check.CancelPrintableCheckResponse.CancelPrintableCheckSuccess",
                        "id": 1
                      },
                      "error": {
                        "type": "squareup.bbfrontend.common.printable_check.CancelPrintableCheckResponse.CancelPrintableCheckError",
                        "id": 2
                      }
                    },
                    "nested": {
                      "CancelPrintableCheckSuccess": {
                        "fields": {}
                      },
                      "CancelPrintableCheckError": {
                        "fields": {
                          "title": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "subtitle": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "button": {
                            "type": "squareup.bbfrontend.common.component.ButtonDescription",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "result": {
                        "oneof": ["success", "error"]
                      }
                    }
                  },
                  "BootstrapPrintableCheckManagementResponse": {
                    "fields": {
                      "printAction": {
                        "type": "squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementResponse.Action",
                        "id": 1,
                        "rule": "optional"
                      },
                      "downloadAction": {
                        "type": "squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementResponse.Action",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cancelAction": {
                        "type": "squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementResponse.CancelAction",
                        "id": 3,
                        "rule": "optional"
                      },
                      "logEvents": {
                        "type": "squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Management",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Action": {
                        "fields": {
                          "icon": {
                            "type": "squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 1,
                            "rule": "optional"
                          },
                          "title": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CancelAction": {
                        "fields": {
                          "icon": {
                            "type": "squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 1,
                            "rule": "optional"
                          },
                          "title": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "warningDialog": {
                            "type": "squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementResponse.CancelAction.WarningDialog",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "WarningDialog": {
                            "fields": {
                              "title": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "subtitle": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "doNothingButton": {
                                "type": "squareup.bbfrontend.common.component.ButtonDescription",
                                "id": 3,
                                "rule": "optional"
                              },
                              "cancelButton": {
                                "type": "squareup.bbfrontend.common.component.ButtonDescription",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "CreatePrintableCheckUnrecoverableError": {
                    "fields": {
                      "icon": {
                        "type": "squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 1,
                        "rule": "optional"
                      },
                      "title": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "subtitle": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "button": {
                        "type": "squareup.bbfrontend.common.component.ButtonDescription",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.DownloadPrintableCheckResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.CancelPrintableCheckResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.CancelPrintableCheckResponse?.nested?.CancelPrintableCheckSuccess && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.CancelPrintableCheckResponse?.nested?.CancelPrintableCheckError && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.BootstrapPrintableCheckManagementResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.BootstrapPrintableCheckManagementResponse?.nested?.Action && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.BootstrapPrintableCheckManagementResponse?.nested?.CancelAction && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.BootstrapPrintableCheckManagementResponse?.nested?.CancelAction?.nested?.WarningDialog && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.CreatePrintableCheckUnrecoverableError) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DownloadPrintableCheckResponse @ squareup/bbfrontend/common/printable_check/printable_check_responses.proto at 15:1
 */
export const DownloadPrintableCheckResponse = $root.lookupType('squareup.bbfrontend.common.printable_check.DownloadPrintableCheckResponse');
fixType(DownloadPrintableCheckResponse, {
  pdfFilename: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DownloadPrintableCheckResponse);
/**
 * SOURCE CancelPrintableCheckResponse @ squareup/bbfrontend/common/printable_check/printable_check_responses.proto at 22:1
 */
export const CancelPrintableCheckResponse = $root.lookupType('squareup.bbfrontend.common.printable_check.CancelPrintableCheckResponse');
fixType(CancelPrintableCheckResponse);
Builder.createAndAttachToType(CancelPrintableCheckResponse);
/**
 * SOURCE CancelPrintableCheckSuccess @ squareup/bbfrontend/common/printable_check/printable_check_responses.proto at 33:3
 */
CancelPrintableCheckResponse.CancelPrintableCheckSuccess = $root.lookupType('squareup.bbfrontend.common.printable_check.CancelPrintableCheckResponse.CancelPrintableCheckSuccess');
fixType(CancelPrintableCheckResponse.CancelPrintableCheckSuccess);
Builder.createAndAttachToType(CancelPrintableCheckResponse.CancelPrintableCheckSuccess);
/**
 * SOURCE CancelPrintableCheckError @ squareup/bbfrontend/common/printable_check/printable_check_responses.proto at 35:3
 */
CancelPrintableCheckResponse.CancelPrintableCheckError = $root.lookupType('squareup.bbfrontend.common.printable_check.CancelPrintableCheckResponse.CancelPrintableCheckError');
fixType(CancelPrintableCheckResponse.CancelPrintableCheckError, {
  title: {
    notEmpty: true
  },
  subtitle: {
    notEmpty: true
  },
  button: {
    required: true
  }
});
Builder.createAndAttachToType(CancelPrintableCheckResponse.CancelPrintableCheckError);
/**
 * SOURCE BootstrapPrintableCheckManagementResponse @ squareup/bbfrontend/common/printable_check/printable_check_responses.proto at 45:1
 */
export const BootstrapPrintableCheckManagementResponse = $root.lookupType('squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementResponse');
fixType(BootstrapPrintableCheckManagementResponse);
Builder.createAndAttachToType(BootstrapPrintableCheckManagementResponse);
/**
 * SOURCE Action @ squareup/bbfrontend/common/printable_check/printable_check_responses.proto at 51:3
 */
BootstrapPrintableCheckManagementResponse.Action = $root.lookupType('squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementResponse.Action');
fixType(BootstrapPrintableCheckManagementResponse.Action, {
  icon: {
    required: true
  },
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BootstrapPrintableCheckManagementResponse.Action);
/**
 * SOURCE CancelAction @ squareup/bbfrontend/common/printable_check/printable_check_responses.proto at 56:3
 */
BootstrapPrintableCheckManagementResponse.CancelAction = $root.lookupType('squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementResponse.CancelAction');
fixType(BootstrapPrintableCheckManagementResponse.CancelAction, {
  icon: {
    required: true
  },
  title: {
    notEmpty: true
  },
  warningDialog: {
    required: true
  }
});
Builder.createAndAttachToType(BootstrapPrintableCheckManagementResponse.CancelAction);
/**
 * SOURCE WarningDialog @ squareup/bbfrontend/common/printable_check/printable_check_responses.proto at 61:5
 */
BootstrapPrintableCheckManagementResponse.CancelAction.WarningDialog = $root.lookupType('squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementResponse.CancelAction.WarningDialog');
fixType(BootstrapPrintableCheckManagementResponse.CancelAction.WarningDialog, {
  title: {
    notEmpty: true
  },
  subtitle: {
    notEmpty: true
  },
  doNothingButton: {
    required: true
  },
  cancelButton: {
    required: true
  }
});
Builder.createAndAttachToType(BootstrapPrintableCheckManagementResponse.CancelAction.WarningDialog);
/**
 * SOURCE CreatePrintableCheckUnrecoverableError @ squareup/bbfrontend/common/printable_check/printable_check_responses.proto at 74:1
 */
export const CreatePrintableCheckUnrecoverableError = $root.lookupType('squareup.bbfrontend.common.printable_check.CreatePrintableCheckUnrecoverableError');
fixType(CreatePrintableCheckUnrecoverableError, {
  icon: {
    required: true
  },
  title: {
    notEmpty: true
  },
  subtitle: {
    notEmpty: true
  },
  button: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePrintableCheckUnrecoverableError);